<h2 mat-dialog-title>Employee Directory</h2>

<span mat-dialog-close class="btn-mat-dialog-close">
  <img src="assets/images/close-icon-gray.svg" alt="Close" title="Close" />
</span>
<mat-dialog-content>
  <div class="d-flex justify-content-between mt-0">
    <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="form-field">
            <mat-form-field appearance="fill" class="full-width">
              <mat-select #selectJobRole placeholder="Please Select Job Role" [(value)]="jobRoleState.selected"
                (selectionChange)="onJobRoleChange($event.value)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="jobRoleNameSearchCtrl" placeholderLabel="Search Job Role..."
                    noEntriesFoundLabel="No results">
                  </ngx-mat-select-search>
                </mat-option>
                @if (!jobRoleState.loading || jobRoleState.data.length > 0) {
                <mat-option [value]="'All'">All Job Roles</mat-option>
                } @for (job of jobRoleState.data; track job.id) {
                <mat-option [value]="job.id">
                  {{ job.name }}
                </mat-option>
                } @if (jobRoleState.loading && jobRoleState.data.length > 0) {
                <mat-option class="loading-option" disabled>
                  <div style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    ">
                    <mat-spinner diameter="20" style="margin-right: 8px"></mat-spinner>
                    <span>Loading more...</span>
                  </div>
                </mat-option>
                } @if (jobRoleState.loading && !jobRoleState.data.length) {
                <mat-option class="loading-option" disabled>
                  <div style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    ">
                    <mat-spinner diameter="20" style="margin-right: 8px"></mat-spinner>
                    <span>Loading...</span>
                  </div>
                </mat-option>
                } @if (!jobRoleState.loading && jobRoleState.data.length === 0) {
                <mat-option class="loading-option" disabled>
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <span>No Data Found...</span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-field">
            <mat-form-field appearance="fill" class="full-width">
              <mat-select #selectUniversity placeholder="Select University" [(value)]="universityState.selected"
                (selectionChange)="onUniversityChange($event.value)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="universityNameSearchCtrl"
                    placeholderLabel="Search University..." noEntriesFoundLabel="No results">
                  </ngx-mat-select-search>
                </mat-option>
                @if (!universityState.loading || universityState.data.length > 0) {
                <mat-option [value]="'All'"> All Universities </mat-option>
                } @for (university of universityState.data; track university.id) {
                <mat-option [value]="university.id">
                  {{ university.name | titlecase }}
                </mat-option>
                } @if (universityState.loading && universityState.data.length > 0) {
                <mat-option class="loading-option" disabled>
                  <div style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    ">
                    <mat-spinner diameter="20" style="margin-right: 8px"></mat-spinner>
                    <span>Loading more...</span>
                  </div>
                </mat-option>
                } @if (universityState.loading && !universityState.data.length) {
                <mat-option class="loading-option" disabled>
                  <div style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    ">
                    <mat-spinner diameter="20" style="margin-right: 8px"></mat-spinner>
                    <span>Loading...</span>
                  </div>
                </mat-option>
                } @if (!universityState.loading && universityState.data.length === 0) {
                <mat-option class="loading-option" disabled>
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <span>No Data Found...</span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-field">
            <mat-form-field appearance="fill" class="full-width">
              <input matInput type="search" placeholder="Search By User Name" [formControl]="employeeNameSearchCtrl" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-content>
  <div #scrollContainer class="table-responsive" style="overflow-x: auto; height: 60vh">
    <table mat-table [dataSource]="employeeState.data" class="full-width">
      <ng-container matColumnDef="images">
        <th mat-header-cell *matHeaderCellDef sticky class="text-start" width="15%">
          Profile
        </th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <img (click)="openImageDialog(element.profileImage)"
            [src]="element.profileImage || './assets/images/favicon_crizac.png'" alt="User" class="profile-pic_zoom" />
        </td>
      </ng-container>

      <!-- User Name -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef sticky>User Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fullName }}
          <span *ngIf="element?.gender">({{ element.gender | titlecase }})</span>
          <span class="d-block">
            <span class="text-success">Status: </span>
            <span class="text-cell-light-color">
              {{ element?.loginStatus }} </span><br />
            <span class="text-danger">Home Access: </span>
            <span class="text-cell-light-color">
              {{ element?.homeAccess }} </span><br />
            <span class="text-success">User Name: </span>
            <span class="text-cell-light-color">
              {{ element?.username }}
            </span>
          </span>
          <span class="d-block" *ngIf="element?.joiningDate">
            <span class="text-success">Joining Date: </span>
            <span class="text-cell-light-color">
              {{ element?.joiningDate | date : "dd-MMM-yyyy" }}
            </span>
          </span>
          <span class="d-block" *ngIf="element?.branch">
            <span class="text-success">Location: </span>
            <span class="text-cell-light-color">
              {{ element?.branch }}
            </span>
          </span>
        </td>
      </ng-container>

      <!-- User Details -->
      <ng-container matColumnDef="userDetails">
        <th mat-header-cell *matHeaderCellDef sticky>
          User Details / University
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="d-block">
            <span class="text-success">User Group: </span>
            <span class="text-cell-light-color">
              {{ element?.userGroupName }} </span><br />
            <span class="text-success">Supervisor: </span>
            <span class="text-cell-light-color">
              {{ element?.supervisor }} </span><br />
            <span class="text-success">Supervisor Number: </span>
            <span class="text-cell-light-color">
              {{ element?.supervisorNumber }} </span><br />
            <span class="text-success">Employee Cabin: </span>
            <span class="text-cell-light-color"> {{ element?.empCabin }} </span><br />
            <span class="text-success">Employee Seat No: </span>
            <span class="text-cell-light-color"> {{ element?.empSeat }} </span><br />
            <span class="text-success">Job Role: </span>
            <span class="text-cell-light-color"> {{ element?.jobRole }} </span><br />
            <span class="text-success">Employee Designation: </span>
            <span class="text-cell-light-color">
              {{ element?.empDesgination }} </span><br />
            <span class="text-success">Employee Department: </span>
            <span class="text-cell-light-color">
              {{ element?.jobDetails }}
            </span>
          </span>
          <ul *ngIf="element?.universityWithJRMAndURM?.length">
            <ng-container *ngFor="let uni of element?.universityWithJRMAndURM; let i = index">
              <li *ngIf="i < 1 || element.isExpanded" class="university-item">
                <!-- University Name -->
                <div class="university-name">
                  <strong>{{ uni.name }}</strong>
                </div>

                <!-- JRM Section -->
                <div *ngIf="uni.JRM" class="university-detail jrm-detail">
                  <span class="text-success">SRM: </span>
                  {{ uni.JRM }}
                </div>

                <!-- URM Section -->
                <div *ngIf="uni.URM" class="university-detail urm-detail">
                  <span class="text-success">URM: </span>
                  {{ uni.URM }}
                </div>
                <!-- Tenant Name -->
                <div class="university-detail urm-detail">
                  <span class="text-success">Tenant: </span>
                  <strong>{{ uni.tenant }}</strong>
                </div>
              </li>
            </ng-container>
          </ul>
          <a *ngIf="element?.universityWithJRMAndURM?.length > 1" 
             href="javascript:void(0)" 
             class="text-primary text-decoration-none mt-1 d-inline-block" 
             style="font-size: 13px;"
             (click)="element.isExpanded = !element.isExpanded">
            {{ element.isExpanded ? 'View Less' : '+ ' + (element.universityWithJRMAndURM.length - 1) + ' More University' }}
          </a>
        </td>
      </ng-container>

      <!-- Contact Info -->
      <ng-container matColumnDef="contactInfo">
        <th mat-header-cell *matHeaderCellDef sticky>Contact Info</th>
        <td mat-cell *matCellDef="let element">
          <span class="d-block">
            <span class="text-success">
              <img src="./assets/images/call-icon-blue.svg" alt="call" title="Call" width="15" height="15" />
            </span>
            <span class="text-cell-light-color cursor-pointer" matTooltip="Call Mobile Number"
              matTooltipPosition="above" (click)="outboundCall(element.mobileNumber)">
              {{ element?.mobileNumber }} (M) </span><br *ngIf="element?.landlineNumber" />
            <span class="text-success" *ngIf="element?.landlineNumber"><img src="./assets/images/call-icon-blue.svg"
                alt="call" title="Call" width="15" height="15" />
            </span>
            <span class="text-cell-light-color" *ngIf="element?.landlineNumber" matTooltip="Office Number"
              matTooltipPosition="above">
              {{ element?.landlineNumber }}(O) </span><br />
            <span class="text-success" *ngIf="
                element.extNumber !== '00' &&
                element.extNumber !== '0' &&
                element.extNumber !== '' &&
                element.extNumber !== null
              "><img src="./assets/images/call-log-icon-gray.svg" alt="call" title="Call" width="15" height="15" />
            </span>
            <span class="text-cell-light-color cursor-pointer" matTooltip="Extension Number" *ngIf="
                element.extNumber !== '00' &&
                element.extNumber !== '0' &&
                element.extNumber !== '' &&
                element.extNumber !== null
              " (click)="extboundCall(element.extNumber)">
              {{ element?.extNumber }}
            </span>
          </span>

          <div *ngIf="element?.aliasMail" class="mt-10">
            <span class="text-success">Alias Emails list :</span>

            <ul *ngIf="getEmails(element?.aliasMail).length > 0" class="ms-3">
              <li *ngFor="let email of getEmails(element?.aliasMail)" class="ms-2">
                {{ email }}
              </li>
            </ul>
          </div>
          <span [ngClass]="{
              'text-danger': element?.external_email_access === 'yes',
              'text-success': element?.external_email_access === 'no'
            }">
            Allow Externals Emails :
            {{
            element?.external_email_access === "yes"
            ? "Yes"
            : element?.external_email_access === "no"
            ? "No"
            : "N/A"
            }}
          </span>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <app-no-data-found *ngIf="!employeeState?.data?.length"></app-no-data-found>
  </div>
</mat-dialog-content>

<!-- Image Preview Dialog Template -->
<ng-template #imagePreview let-data>
  <div class="image-preview-container" 
       style="position: relative; padding: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; box-sizing: border-box; overflow: hidden; background: #000; border-radius: 12px; border: 2px solid rgba(255, 255, 255, 0.15); box-shadow: 0 10px 40px rgba(0,0,0,0.5);">
    
    <!-- Controls Toolbar -->
    <div style="position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); z-index: 20; display: flex; gap: 15px; background: rgba(255,255,255,0.2); backdrop-filter: blur(10px); padding: 10px 20px; border-radius: 30px; box-shadow: 0 4px 6px rgba(0,0,0,0.3);">
      <button (click)="zoomOut()" style="color: white; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%;" title="Zoom Out">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
      </button>
      <button (click)="zoomIn()" style="color: white; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%;" title="Zoom In">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
      </button>
      <button (click)="rotateImage()" style="color: white; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%;" title="Rotate">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.92-10.26l1.08 1.08"/></svg>
      </button>
      <button (click)="resetImage()" style="color: white; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%;" title="Reset">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
      </button>
    </div>

    <!-- Close Button -->
    <span class="btn-mat-dialog-close" (click)="closeImageDialog()" style="position: absolute; right: 15px; top: 15px; z-index: 20; cursor: pointer; background: rgba(255,255,255,0.2); backdrop-filter: blur(10px); border-radius: 50%; padding: 8px; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.2);">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </span>

    <!-- Draggable Image Container -->
    <div 
        (wheel)="onWheel($event)"
        (mousedown)="onDragStart($event)" 
        (mousemove)="onDragMove($event)" 
        (mouseup)="onDragEnd()" 
        (mouseleave)="onDragEnd()"
        (touchstart)="onDragStart($event)" 
        (touchmove)="onDragMove($event)" 
        (touchend)="onDragEnd()"
        style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; cursor: grab;"
        [style.cursor]="isDragging() ? 'grabbing' : 'grab'">
      <img [src]="data" alt="Image Preview" 
           [style.transform]="'translate(' + translateX() + 'px, ' + translateY() + 'px) scale(' + zoomLevel() + ') rotate(' + rotation() + 'deg)'"
           style="max-width: 100%; max-height: 100%; object-fit: contain; transition: transform 0.2s ease-out; user-select: none;"
           [style.transition]="isDragging() ? 'none' : 'transform 0.2s ease-out'" draggable="false" />
    </div>
  </div>
</ng-template>